import React from 'react';

function GasOutletPoint() {
  return (
    <>
      <style>{`
        .gas-container {
          padding: 2rem;
          background-color: #f8f9fa;
          font-family: 'Segoe UI', sans-serif;
        }

        .gas-container h1 {
          font-size: 2.5rem;
          color: #2c3e50;
          text-align: center;
          margin-bottom: 2rem;
        }

        .image-grid {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 2rem;
        }

        .image-grid img {
          width: 100%;
          max-width: 500px;
          border-radius: 10px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        section {
          max-width: 900px;
          margin: 0 auto;
          background-color: #fff;
          padding: 2rem;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.05);
        }

        section h2 {
          font-size: 2rem;
          margin-bottom: 1rem;
          color: #34495e;
        }

        section p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #555;
          margin-bottom: 1rem;
        }

        @media (max-width: 768px) {
          .gas-container h1 {
            font-size: 2rem;
          }

          section h2 {
            font-size: 1.5rem;
          }

          section p {
            font-size: 1rem;
          }

          .image-grid img {
            max-width: 90%;
          }
        }
      `}</style>

      <main className="gas-container">
        <h1>Gas Outlet Point (PB Compatible)</h1>

        <div className="image-grid">
          <img src="gt.png" alt="Gas Outlet Point" />
        </div>

        <section>
          <h2>Specifications</h2>
          <p>The medical gas outlet shall be a Sigma FL-1 series.</p>
          <p>
            Outlets shall be manufactured with a 6 - 1/2" [165 mm] length type
            "K" 1/2" [12.7 mm] outside diameter (3/8" nominal) size copper inlet
            pipe stub which is silver brazed to the outlet body. The body shall
            be of 1 - 5/16" [33 mm] diameter, one-piece brass construction.
          </p>
          <p>
            For positive pressure gas services, the outlet shall be equipped
            with a primary and secondary check valve and the secondary check
            valve shall be rated at a maximum of 200 psi [1,379 kPa] in the
            event the primary check valve is removed for maintenance.
          </p>
          <p>
            Outlet bodies shall be gas specific by indexing each gas service to
            a gas specific dual pin indexing arrangement on the respective
            identification module.
          </p>
          <p>
            A large color-coded front plate shall be used for ease of gas
            identification and aesthetic appeal.
          </p>
          <p>
            With the back rough-in mounted the outlet shall adjust up to 3/4"
            [19 mm] variation in mounting plate thickness.
          </p>
          <p>
            The latch valve assembly shall be Puritan-Bennett Quick Disconnect
            compatible and accept only corresponding Puritan-Bennett type gas
            specific adapters.
          </p>
          <p>
            All outlets shall be cleaned and degreased for medical gas service,
            factory assembled and tested.
          </p>
        </section>
      </main>
    </>
  );
}

export default GasOutletPoint;
